import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitoratnagiricab() {



const cardData = {
  keyword: " Mumbai to Ratnagiri Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Ratnagiri cab services for travelers planning a scenic trip to the beautiful Konkan coast of Maharashtra. Ratnagiri is famous for its pristine beaches, historic forts, lush greenery, and the world-famous Alphonso mangoes. Whether you are planning a relaxing beach vacation, a family trip, a cultural tour, or a Konkan sightseeing journey, our cab service ensures a smooth and safe travel experience with experienced drivers and well-maintained vehicles. The road distance from Mumbai to Ratnagiri is approximately 330 km and the journey offers breathtaking views of the Sahyadri hills, rivers, and coastal landscapes. We provide flexible booking options including one-way cab service, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, skilled chauffeurs experienced in Konkan routes, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Ratnagiri cab booking.",

topPlaces: [
  {
    title: "Ganpatipule Temple and Beach",
    description:
      "Ganpatipule Temple is one of the most famous pilgrimage destinations in the Konkan region and is located near Ratnagiri. The temple is dedicated to Lord Ganesha and is believed to house a naturally formed idol of the deity. The temple sits beside the beautiful Ganpatipule Beach, which is known for its clean shoreline, golden sand, and clear waters. Devotees and tourists visit the temple for spiritual blessings and enjoy peaceful walks along the beach afterward. Traveling by cab from Mumbai allows visitors to comfortably reach this sacred and scenic destination while enjoying the coastal beauty of the Konkan region."
  },
  {
    title: "Ratnadurg Fort",
    description:
      "Ratnadurg Fort is a historic sea fort located on a hill overlooking the Arabian Sea near Ratnagiri city. Built during the Bahmani period and later controlled by the Marathas, the fort offers spectacular panoramic views of the coastline and surrounding hills. Inside the fort complex, visitors can explore the Bhagwati Temple, ancient fort walls, and scenic viewpoints. The location is perfect for history lovers and photographers who want to experience both heritage and natural beauty. A comfortable cab journey from Mumbai allows tourists to easily explore this historic landmark."
  },
  {
    title: "Thiba Palace",
    description:
      "Thiba Palace is a historic palace in Ratnagiri that was built for the exiled King Thibaw of Burma (Myanmar) during the British colonial period. The palace features beautiful architecture, large windows, and scenic views of the surrounding hills and coastline. Today, it houses a small museum that displays historical artifacts and information about the king’s life in exile. Visitors interested in history and architecture often explore the palace and its surrounding gardens. A cab trip from Mumbai makes it convenient to visit this unique historical site."
  },
  {
    title: "Mandvi Beach",
    description:
      "Mandvi Beach is one of the most popular beaches in Ratnagiri and is known for its soft sand, calm waters, and scenic surroundings. The beach is ideal for relaxing walks, sunset views, and enjoying the refreshing sea breeze. Visitors often spend time here taking photographs, enjoying local street food, and watching fishing boats along the shore. The beach is easily accessible from the city and offers a peaceful atmosphere for tourists. Traveling by cab from Mumbai allows visitors to comfortably explore Mandvi Beach during their Ratnagiri trip."
  },
  {
    title: "Jaigad Fort and Lighthouse",
    description:
      "Jaigad Fort is a historic coastal fort located near the entrance of the Shastri River where it meets the Arabian Sea. The fort offers stunning views of the ocean, nearby Jaigad Lighthouse, and the surrounding Konkan coastline. Visitors enjoy exploring the fort walls, watching ships pass through the harbor, and capturing scenic photographs. The nearby lighthouse adds to the beauty of the location and is a popular spot for sightseeing. A cab journey from Mumbai allows travelers to conveniently include Jaigad Fort in their Ratnagiri exploration."
  },
  {
    title: "Pawas (Swami Swaroopanand Ashram)",
    description:
      "Pawas is a peaceful spiritual destination near Ratnagiri and is known as the birthplace and residence of Swami Swaroopanand Maharaj. The ashram attracts devotees who come to seek blessings and experience the calm spiritual environment of the place. The surroundings are quiet and filled with natural beauty, making it ideal for meditation and reflection. Visitors often include Pawas in their Ratnagiri itinerary for a spiritual experience. Traveling by cab ensures convenient access to this sacred location."
  },
  {
    title: "Bhatye Beach",
    description:
      "Bhatye Beach is a long and scenic beach located just outside Ratnagiri city and is known for its peaceful atmosphere and beautiful coastal views. The beach is lined with casuarina trees and offers a perfect place for long walks, photography, and enjoying the sunset. It is less crowded compared to other beaches, making it ideal for travelers who want a quiet and relaxing experience by the sea. A cab ride from Mumbai allows tourists to easily reach Bhatye Beach and spend time enjoying the natural beauty of the Konkan coast."
  },
  {
    title: "Marine Fish Museum",
    description:
      "The Marine Fish Museum in Ratnagiri is an interesting attraction where visitors can learn about different species of marine life found along the Konkan coast. The museum displays preserved fish, sea creatures, and educational information about marine ecosystems and fishing practices. It is a popular place for students, families, and tourists interested in marine biology and coastal culture. Traveling by cab makes it easy to include the museum in a Ratnagiri sightseeing tour."
  },
  {
    title: "Velneshwar Beach",
    description:
      "Velneshwar Beach is a serene and less crowded beach located near Ratnagiri and is known for its natural beauty and clean shoreline. The beach is surrounded by coconut trees and small fishing villages, creating a picturesque coastal environment. Visitors often come here for peaceful relaxation, photography, and to enjoy the calm sea breeze. The nearby Velneshwar Temple dedicated to Lord Shiva also attracts devotees. A cab journey from Mumbai allows travelers to comfortably explore this hidden gem of the Konkan region."
  },
  {
    title: "Aare Ware Beach",
    description:
      "Aare Ware Beach is considered one of the most scenic coastal stretches near Ratnagiri. The twin beaches are located along a winding coastal road that offers breathtaking views of the Arabian Sea and surrounding cliffs. The location is perfect for photography, road trips, and enjoying the untouched natural beauty of the Konkan coast. Visitors often stop here to admire the panoramic ocean views and relax in the peaceful environment. Traveling by cab from Mumbai allows tourists to enjoy the beautiful coastal drive and explore this spectacular destination."
  }
],



services: [
{
name: "Mumbai to Ratnagiri Cab",
description: "Mumbai to Ratnagiri cab service offers comfortable long-distance transportation from Mumbai to the beautiful coastal city of Ratnagiri in the Konkan region. The route passes through scenic highways, lush green hills, and coastal landscapes making it ideal for tourism travel. Our vehicles are well-maintained and suitable for highway journeys with spacious seating and luggage space. Professional drivers ensure safe driving and punctual pickup from homes, hotels, offices, railway stations, and airport terminals across Mumbai. Air-conditioned vehicles ensure relaxed travel for families and groups. Ideal for Konkan vacations, family visits, and tourism trips. Flexible booking options allow easy travel planning."
},
{
name: "Mumbai to Ratnagiri Taxi",
description: "Mumbai to Ratnagiri taxi service provides reliable intercity transportation for travelers heading to the Konkan coastal destination of Ratnagiri. Vehicles provide smooth highway performance and comfortable seating suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, beach trips, family visits, and business travel. Air-conditioned vehicles ensure comfortable travel experiences throughout the journey. Flexible taxi booking options allow convenient ride scheduling."
},
{
name: "Mumbai to Ratnagiri Cab Service",
description: "Mumbai to Ratnagiri cab service provides dependable road transportation between Mumbai and the scenic Konkan region. Vehicles used for this route offer comfortable seating and smooth highway performance suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup is available from homes, offices, hotels, railway stations, and airport terminals. Ideal for tourism travel, family trips, and holiday journeys to Ratnagiri beaches and temples. Spacious vehicles ensure relaxed travel experiences. Flexible booking options allow passengers to easily schedule their rides."
},
{
name: "Mumbai to Ratnagiri Taxi Service",
description: "Mumbai to Ratnagiri taxi service offers convenient travel solutions for passengers visiting the Konkan coast for vacations, family visits, or business travel. Vehicles are designed for long-distance journeys and provide comfortable seating for passengers and luggage. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel and coastal trips. Air-conditioned vehicles ensure comfortable journeys across the scenic route."
},
{
name: "Cab from Mumbai to Ratnagiri",
description: "Cab from Mumbai to Ratnagiri provides reliable transportation for travelers planning trips to the Konkan coastal district of Ratnagiri. Vehicles provide smooth ride quality and comfortable seating suitable for highway journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for beach tourism, family visits, and holiday travel. Spacious vehicles ensure comfortable journeys throughout the trip. Flexible booking options allow easy ride reservations."
},
{
name: "Taxi from Mumbai to Ratnagiri",
description: "Taxi from Mumbai to Ratnagiri provides dependable travel options for passengers visiting the Konkan coast for tourism and family trips. Vehicles offer smooth highway performance and comfortable seating suitable for long-distance travel. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals. Ideal for family vacations, beach visits, and tourism travel. Air-conditioned vehicles ensure relaxed journeys throughout the route."
},
{
name: "Mumbai to Ratnagiri Cab Booking",
description: "Mumbai to Ratnagiri cab booking allows travelers to easily reserve vehicles for Konkan travel and coastal tourism trips. Online and phone booking options provide instant confirmation and convenient ride scheduling. Vehicles provide comfortable seating and smooth highway travel for long-distance journeys. Professional drivers ensure punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism trips and family travel."
},
{
name: "Mumbai to Ratnagiri Taxi Booking Online",
description: "Mumbai to Ratnagiri taxi booking online provides convenient digital reservations for travelers planning trips to Ratnagiri. Passengers can easily schedule pickups and receive instant confirmation for their travel plans. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals."
},
{
name: "Mumbai to Ratnagiri Cab Price",
description: "Mumbai to Ratnagiri cab price options provide transparent fare estimates for passengers planning intercity journeys to the Konkan coast. Pricing depends on vehicle category, distance, and travel duration. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size. Professional drivers ensure punctual pickup and safe highway driving services across Mumbai. Transparent pricing allows travelers to easily plan their trip budget."
},
{
name: "Mumbai to Ratnagiri Taxi Fare",
description: "Mumbai to Ratnagiri taxi fare services offer flexible pricing options depending on vehicle type and travel duration. Passengers can select economical sedans or spacious SUVs for their travel needs. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals. Ideal for tourism travel, family visits, and coastal holiday journeys."
},
{
name: "Mumbai to Ratnagiri One Way Cab",
description: "Mumbai to Ratnagiri one way cab service provides economical transportation without return charges for passengers traveling one direction. Vehicles offer comfortable seating and smooth highway performance suitable for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Ideal for travelers relocating, tourists visiting Konkan, or passengers traveling for family visits."
},
{
name: "Mumbai to Ratnagiri Round Trip Taxi",
description: "Mumbai to Ratnagiri round trip taxi service provides convenient travel for passengers planning return journeys after visiting Ratnagiri. Vehicles are suitable for long-distance highway travel and multi-day trips. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Ideal for family vacations, Konkan beach tours, and tourism travel."
},
{
name: "Mumbai to Ratnagiri Innova Cab",
description: "Mumbai to Ratnagiri Innova cab service provides spacious MPV transportation ideal for families and group travelers visiting the Konkan coast. The Toyota Innova offers comfortable seating, smooth highway stability, and ample luggage space for long-distance journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
},
{
name: "Mumbai to Ratnagiri Ertiga Cab",
description: "Mumbai to Ratnagiri Ertiga cab service offers comfortable MPV transportation suitable for small families and groups traveling to Ratnagiri. The Maruti Ertiga provides spacious seating and smooth ride quality for highway journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
},
{
name: "Konkan Tour Cab Mumbai",
description: "Konkan tour cab from Mumbai offers convenient transportation for travelers planning trips across the scenic Konkan region including Ratnagiri, Ganpatipule, and nearby beaches. Vehicles provide comfortable seating and smooth highway travel suitable for tourism journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Ideal for family vacations, coastal road trips, and tourism travel."
}
],

tableData: [
["Mumbai to Ratnagiri Cab","Mumbai to Ratnagiri Taxi"],
["Mumbai to Ratnagiri Cab Service","Mumbai to Ratnagiri Taxi Service"],
["Cab from Mumbai to Ratnagiri","Taxi from Mumbai to Ratnagiri"],
["Mumbai to Ratnagiri Cab Booking","Mumbai to Ratnagiri Taxi Booking Online"],
["Mumbai to Ratnagiri Cab Price","Mumbai to Ratnagiri Taxi Fare"],
["Mumbai to Ratnagiri One Way Cab","Mumbai to Ratnagiri Round Trip Taxi"],
["Mumbai to Ratnagiri Innova Cab","Mumbai to Ratnagiri Ertiga Cab"],
["Konkan Tour Cab Mumbai","Ratnagiri Taxi from Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Konkan Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through the scenic Konkan coastal routes from Mumbai to Ratnagiri. They are familiar with ghat roads, coastal highways, and local conditions ensuring a safe and smooth journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs provides transparent pricing for Mumbai to Ratnagiri cab bookings. Customers receive clear details about per-kilometer charges, toll fees, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Ratnagiri cab service operates 24 hours a day. Whether you want to start early morning or travel overnight, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance journey."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day travel packages from Mumbai to Ratnagiri."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Ratnagiri journey begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Konkan Travel Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Ratnagiri trips. Our punctual drivers, comfortable vehicles, and professional service ensure a relaxing Konkan coastal journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Ratnagiri?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to Ratnagiri for both one-way and round-trip travel." },
  { question: "What is the distance from Mumbai to Ratnagiri?", answer: "The distance from Mumbai to Ratnagiri is approximately 330 km and the journey usually takes around 7 to 8 hours depending on traffic and road conditions." },
  { question: "Can I book a one-way cab from Mumbai to Ratnagiri?", answer: "Yes, we offer both one-way and round-trip cab services between Mumbai and Ratnagiri." },
  { question: "Which vehicles are available for this route?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Ratnagiri cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, sightseeing, or refreshment breaks." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and Konkan tourist seasons." },
  { question: "Can we visit Ganpatipule during the trip?", answer: "Yes, many travelers combine Ratnagiri travel with Ganpatipule Temple and nearby Konkan sightseeing." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Patil",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Ratnagiri trip. The driver handled the Konkan roads very well and the car was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Deshmukh",
    feedback:
      "Excellent cab service for Konkan travel. Smooth ride, professional driver, and very reliable service.",
    rating: 5
  }
];










































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ratnagiri Cab",
  "description": "Omshree Cab provides reliable cab services from Mumbai to Ratnagiri for one-way trips, round trips, and Konkan tours. Choose from Innova, Ertiga, and other well-maintained vehicles for a safe, comfortable, and punctual journey. Flexible booking options with transparent pricing make travel hassle-free for family, corporate, and leisure trips.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "890"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Mumbai to Ratnagiri Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Omshree Cab offers cab services from Mumbai to Ratnagiri for one-way trips, round trips, and Konkan tours. Travel safely and comfortably with Innova, Ertiga, and other vehicles. Flexible bookings and transparent pricing for hassle-free journeys." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/70.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoratnagiricab;